import axios from 'axios';
import queryString from 'query-string';
import { queryStringifyOptions } from 'utils/constants';

export const getMeEnriched = ({ enrich_with }) =>
    axios.get(
        `/users/me/enriched?${queryString.stringify({ enrich_with }, queryStringifyOptions)}`
    );
